module.exports = __webpack_public_path__ + "img/the-red-yeti.3580f7c6.svg";